module.exports = __webpack_public_path__ + "static/hab_research_1-c66b9b4ed647141cd84d6f61cc49f329.png";